import axios from 'axios';

export const api = axios.create({
  baseURL: 'https://api2.arecreativa.com.br',
  headers: {
    Authorization: `Bearer ${localStorage.getItem('@Portal:token')}`,
  },
});

export const apiNode = axios.create({
  baseURL: 'https://api2.arecreativa.com.br',
  headers: {
    Authorization: `Bearer ${localStorage.getItem('@Portal:token')}`,
  },
});

export const apiPHP = axios.create({
  baseURL: 'https://api.recreativa.com.br/api',
});

export const apiWordle = axios.create({
  baseURL: 'https://api-wordle.herokuapp.com',
});

const refreshToken = () => {};

apiPHP.interceptors.request.use(
  async (config: any) => {
    if (!config.url.endsWith('planos')) {
      const token = localStorage.getItem('@Portal:token');
      config.headers.Authorization = token ? `Bearer ${token}` : '';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    if (error.response.status === 403) {
      refreshToken();
    }
    return Promise.reject(error);
  }
);

export default api;
